// Module
var code = " <gb-button icon=\"add\" ng-click=\"$ctrl.addWidget()\"> <span translate=\"ADD_NOTIFICATION_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-notification-widget widget=\"$ctrl.widget\"></gb-edit-notification-widget> ";
// Exports
export default code;